import { render } from "./Reset.vue?vue&type=template&id=ff1b46d8&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=ff1b46d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff1b46d8"

export default script